"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _peractoConfig = require("@peracto/peracto-config");

var _Select = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Select"));

var _TextInput = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/TextInput"));

var _Checkbox = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Checkbox"));

var _Slider = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Slider"));

var _File = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/File"));

var _const = require("../const");

var _Lock = _interopRequireDefault(require("./Lock"));

var _Size = _interopRequireDefault(require("./Size"));

var _Group = _interopRequireDefault(require("./Group"));

var _isLocked = _interopRequireDefault(require("../util/isLocked"));

var _getOpposite = _interopRequireDefault(require("../util/getOpposite"));

var _getPositionsForDirection = _interopRequireDefault(require("../util/getPositionsForDirection"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var negativeValues = [];

for (var i = -200; i < 0; i += 5) {
  negativeValues.push({
    label: i,
    value: i
  });
}

var BlockDecoratorForm = function BlockDecoratorForm(_ref) {
  var _ref3, _ref4, _ref5, _TYPE_PADDING, _TYPE_MARGIN, _TYPE_LOCKS, _ref6;

  var _onChange8 = _ref.onChange,
      state = _ref.state,
      options = _ref.options,
      translations = _ref.translations;
  var config = (0, _peractoConfig.useConfig)();

  var _ref2 = config.get('editorConfig') || [],
      colorOptions = _ref2.colorOptions;

  var themeColours = colorOptions || [];
  var _state$STATE_KEY_BACK = state[_const.STATE_KEY_BACKGROUND],
      backgroundDecoratorState = _state$STATE_KEY_BACK === void 0 ? (_ref3 = {}, _defineProperty(_ref3, _const.TYPE_BACKGROUND_MODE, _const.BACKGROUND_MODE_IMAGE_FLAG), _defineProperty(_ref3, _const.TYPE_BACKGROUND_COLOR, null), _defineProperty(_ref3, _const.TYPE_BACKGROUND_COLOR_OPACITY, 1), _defineProperty(_ref3, _const.TYPE_BACKGROUND_IMAGE, ''), _defineProperty(_ref3, _const.TYPE_BACKGROUND_VIDEO, ''), _defineProperty(_ref3, _const.TYPE_BACKGROUND_POSITION, null), _defineProperty(_ref3, _const.TYPE_BACKGROUND_SIZE, null), _defineProperty(_ref3, _const.TYPE_BACKGROUND_REPEAT, null), _defineProperty(_ref3, _const.TYPE_BACKGROUND_LOADING_METHOD, 'normal'), _ref3) : _state$STATE_KEY_BACK,
      _state$STATE_KEY_BORD = state[_const.STATE_KEY_BORDER],
      borderDecoratorState = _state$STATE_KEY_BORD === void 0 ? (_ref4 = {}, _defineProperty(_ref4, _const.TYPE_BORDER_X, 'none'), _defineProperty(_ref4, _const.TYPE_BORDER_Y, 'none'), _defineProperty(_ref4, _const.TYPE_BORDER_COLOR, 'rgba(0,0,0,0.1)'), _defineProperty(_ref4, _const.TYPE_BORDER_WIDTH, 1), _defineProperty(_ref4, _const.TYPE_BORDER_STYLE, 'solid'), _ref4) : _state$STATE_KEY_BORD,
      _state$STATE_KEY_EFFE = state[_const.STATE_KEY_EFFECTS],
      effectDecoratorState = _state$STATE_KEY_EFFE === void 0 ? (_ref5 = {}, _defineProperty(_ref5, _const.TYPE_ANIMATION_STYLE, 'none'), _defineProperty(_ref5, _const.TYPE_ANIMATION_DELAY, 0), _defineProperty(_ref5, _const.TYPE_ANIMATION_DURATION, 1000), _defineProperty(_ref5, _const.TYPE_ANIMATION_HOVER, 'none'), _defineProperty(_ref5, _const.TYPE_BOX_SHADOW, false), _ref5) : _state$STATE_KEY_EFFE,
      _state$STATE_KEY_POSI = state[_const.STATE_KEY_POSITION],
      positionDecoratorState = _state$STATE_KEY_POSI === void 0 ? (_ref6 = {}, _defineProperty(_ref6, _const.TYPE_PADDING, {
    top: null,
    right: null,
    bottom: null,
    left: null
  }), _defineProperty(_ref6, _const.TYPE_MARGIN, {
    top: null,
    right: null,
    bottom: null,
    left: null
  }), _defineProperty(_ref6, _const.TYPE_LOCKS, (_TYPE_LOCKS = {}, _defineProperty(_TYPE_LOCKS, _const.TYPE_PADDING, (_TYPE_PADDING = {}, _defineProperty(_TYPE_PADDING, _const.DIRECTION_VERT, false), _defineProperty(_TYPE_PADDING, _const.DIRECTION_HORZ, false), _TYPE_PADDING)), _defineProperty(_TYPE_LOCKS, _const.TYPE_MARGIN, (_TYPE_MARGIN = {}, _defineProperty(_TYPE_MARGIN, _const.DIRECTION_VERT, false), _defineProperty(_TYPE_MARGIN, _const.DIRECTION_HORZ, false), _TYPE_MARGIN)), _TYPE_LOCKS)), _defineProperty(_ref6, _const.TYPE_PADDING_MOBILE, false), _ref6) : _state$STATE_KEY_POSI,
      _state$STATE_KEY_ANCH = state[_const.STATE_KEY_ANCHOR],
      anchorDecoratorState = _state$STATE_KEY_ANCH === void 0 ? _defineProperty({}, _const.TYPE_ANCHOR_ID, '') : _state$STATE_KEY_ANCH;
  var padding = positionDecoratorState[_const.TYPE_PADDING],
      paddingMobile = positionDecoratorState[_const.TYPE_PADDING_MOBILE],
      margin = positionDecoratorState[_const.TYPE_MARGIN],
      locks = positionDecoratorState[_const.TYPE_LOCKS];
  var backgroundColor = backgroundDecoratorState[_const.TYPE_BACKGROUND_COLOR],
      backgroundColorOpacity = backgroundDecoratorState[_const.TYPE_BACKGROUND_COLOR_OPACITY],
      backgroundImage = backgroundDecoratorState[_const.TYPE_BACKGROUND_IMAGE],
      backgroundVideo = backgroundDecoratorState[_const.TYPE_BACKGROUND_VIDEO],
      backgroundPosition = backgroundDecoratorState[_const.TYPE_BACKGROUND_POSITION],
      backgroundSize = backgroundDecoratorState[_const.TYPE_BACKGROUND_SIZE],
      backgroundRepeat = backgroundDecoratorState[_const.TYPE_BACKGROUND_REPEAT],
      backgroundAltText = backgroundDecoratorState[_const.TYPE_BACKGROUND_ALT_TEXT],
      backgroundLoadingMethod = backgroundDecoratorState[_const.TYPE_BACKGROUND_LOADING_METHOD],
      backgroundMode = backgroundDecoratorState[_const.TYPE_BACKGROUND_MODE];
  var borderX = borderDecoratorState[_const.TYPE_BORDER_X],
      borderY = borderDecoratorState[_const.TYPE_BORDER_Y],
      borderColor = borderDecoratorState[_const.TYPE_BORDER_COLOR],
      borderWidth = borderDecoratorState[_const.TYPE_BORDER_WIDTH],
      borderStyle = borderDecoratorState[_const.TYPE_BORDER_STYLE];
  var animationStyle = effectDecoratorState[_const.TYPE_ANIMATION_STYLE],
      animationDelay = effectDecoratorState[_const.TYPE_ANIMATION_DELAY],
      animationDuration = effectDecoratorState[_const.TYPE_ANIMATION_DURATION],
      animationHover = effectDecoratorState[_const.TYPE_ANIMATION_HOVER],
      boxShadow = effectDecoratorState[_const.TYPE_BOX_SHADOW];
  var anchorId = anchorDecoratorState[_const.TYPE_ANCHOR_ID];

  var onValueChange = function onValueChange(type, pos) {
    return function (selected) {
      var change = _defineProperty({}, pos, selected);

      if ((0, _isLocked["default"])(positionDecoratorState, type, pos)) {
        var oppositePos = (0, _getOpposite["default"])(pos);

        if (oppositePos) {
          change[oppositePos] = selected;
        }
      }

      _onChange8(_defineProperty({}, _const.STATE_KEY_POSITION, _objectSpread(_objectSpread({}, positionDecoratorState), _defineProperty({}, type, _objectSpread(_objectSpread({}, positionDecoratorState[type]), change)))));
    };
  };

  var onLockClick = function onLockClick(type, direction) {
    return function () {
      var locked = !positionDecoratorState[_const.TYPE_LOCKS][type][direction];
      var positionChange = {};

      if (locked) {
        var _objectSpread3;

        var _getPositionsForDirec = (0, _getPositionsForDirection["default"])(direction),
            _getPositionsForDirec2 = _slicedToArray(_getPositionsForDirec, 2),
            primary = _getPositionsForDirec2[0],
            secondary = _getPositionsForDirec2[1];

        var value = positionDecoratorState[type][primary] || positionDecoratorState[type][secondary];
        positionChange = _defineProperty({}, type, _objectSpread(_objectSpread({}, positionDecoratorState[type]), (_objectSpread3 = {}, _defineProperty(_objectSpread3, primary, value), _defineProperty(_objectSpread3, secondary, value), _objectSpread3)));
      }

      _onChange8(_defineProperty({}, _const.STATE_KEY_POSITION, _objectSpread(_objectSpread(_objectSpread({}, positionDecoratorState), _defineProperty({}, _const.TYPE_LOCKS, _objectSpread(_objectSpread({}, positionDecoratorState[_const.TYPE_LOCKS]), _defineProperty({}, type, _objectSpread(_objectSpread({}, positionDecoratorState[_const.TYPE_LOCKS][type]), _defineProperty({}, direction, !positionDecoratorState[_const.TYPE_LOCKS][type][direction])))))), positionChange)));
    };
  };

  var onBackgroundChange = function onBackgroundChange(value, key) {
    _onChange8(_defineProperty({}, _const.STATE_KEY_BACKGROUND, _objectSpread(_objectSpread({}, backgroundDecoratorState), _defineProperty({}, key, value))));
  };

  var onBorderChange = function onBorderChange(value, key) {
    _onChange8(_defineProperty({}, _const.STATE_KEY_BORDER, _objectSpread(_objectSpread({}, borderDecoratorState), _defineProperty({}, key, value))));
  };

  var onEffectChange = function onEffectChange(value, key) {
    _onChange8(_defineProperty({}, _const.STATE_KEY_EFFECTS, _objectSpread(_objectSpread({}, effectDecoratorState), _defineProperty({}, key, value))));
  };

  var onAnchorChange = function onAnchorChange(value, key) {
    _onChange8(_defineProperty({}, _const.STATE_KEY_ANCHOR, _objectSpread(_objectSpread({}, anchorDecoratorState), _defineProperty({}, key, value))));
  };

  var _useState = (0, _react.useState)(backgroundAltText || ''),
      _useState2 = _slicedToArray(_useState, 2),
      internalBackgroundAltText = _useState2[0],
      setInternalBackgroundAltText = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Group["default"], {
    title: "Background"
  }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.backgroundColorInput,
    options: [].concat(_toConsumableArray(options[_const.TYPE_BACKGROUND_COLOR]), _toConsumableArray(themeColours)),
    value: backgroundColor,
    onChange: function onChange(e) {
      return onBackgroundChange(e.value, _const.TYPE_BACKGROUND_COLOR);
    }
  }), backgroundColor && /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    label: "".concat(translations.backgroundColorOpacityInput, " (").concat(Math.floor((backgroundColorOpacity || 1) * 100), "%)"),
    min: 0,
    max: 1,
    step: 0.01,
    value: backgroundColorOpacity || 1,
    onChange: function onChange(e) {
      return onBackgroundChange(e.target.value, _const.TYPE_BACKGROUND_COLOR_OPACITY);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.backgroundModeInput,
    options: options[_const.TYPE_BACKGROUND_MODE],
    value: backgroundMode,
    onChange: function onChange(e) {
      return onBackgroundChange(e.value, _const.TYPE_BACKGROUND_MODE);
    }
  }), backgroundMode === _const.BACKGROUND_MODE_VIDEO_FLAG && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: translations.backgroundVideoInput,
    value: backgroundVideo,
    onChange: function onChange(value) {
      return onBackgroundChange(value, _const.TYPE_BACKGROUND_VIDEO);
    }
  }), /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: translations.backgroundPosterframeInput,
    value: backgroundImage,
    onChange: function onChange(value) {
      return onBackgroundChange(value, _const.TYPE_BACKGROUND_IMAGE);
    }
  })), backgroundMode === _const.BACKGROUND_MODE_IMAGE_FLAG && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: translations.backgroundImageInput,
    value: backgroundImage,
    onChange: function onChange(value) {
      return onBackgroundChange(value, _const.TYPE_BACKGROUND_IMAGE);
    }
  }), backgroundImage && backgroundImage.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.backgroundPositionInput,
    options: options[_const.TYPE_BACKGROUND_POSITION],
    value: backgroundPosition,
    onChange: function onChange(e) {
      return onBackgroundChange(e.value, _const.TYPE_BACKGROUND_POSITION);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.backgroundSizeInput,
    options: options[_const.TYPE_BACKGROUND_SIZE],
    value: backgroundSize,
    onChange: function onChange(e) {
      return onBackgroundChange(e.value, _const.TYPE_BACKGROUND_SIZE);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.backgroundRepeatInput,
    options: options[_const.TYPE_BACKGROUND_REPEAT],
    value: backgroundRepeat,
    onChange: function onChange(e) {
      return onBackgroundChange(e.value, _const.TYPE_BACKGROUND_REPEAT);
    }
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: translations.backgroundAltTextInput,
    value: internalBackgroundAltText,
    onChange: function onChange(e) {
      setInternalBackgroundAltText(e.target.value);
      var onChangeBackgroundAltText = onBackgroundChange(e.target.value, _const.TYPE_BACKGROUND_ALT_TEXT);
      (0, _debounce["default"])(function () {
        return onChangeBackgroundAltText();
      }, 200);
    },
    tooltip: "Adds alt text support to background images, to allow screen readers to read a description of the image's content"
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.backgroundLoadingMethodInput,
    options: options[_const.TYPE_BACKGROUND_LOADING_METHOD],
    value: backgroundLoadingMethod,
    onChange: function onChange(e) {
      return onBackgroundChange(e.value, _const.TYPE_BACKGROUND_LOADING_METHOD);
    },
    tooltip: "Preload should be used sparingly to improve performance, limit use to large above the fold images."
  })))), /*#__PURE__*/_react["default"].createElement(_Group["default"], {
    title: "Spacing"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex align-items-end"
  }, /*#__PURE__*/_react["default"].createElement(_Size["default"], {
    label: "Padding top",
    options: options[_const.TYPE_PADDING],
    value: padding.top,
    onChange: onValueChange('padding', 'top')
  }), /*#__PURE__*/_react["default"].createElement(_Lock["default"], {
    locked: locks.padding.vertical,
    onClick: onLockClick(_const.TYPE_PADDING, _const.DIRECTION_VERT)
  }), /*#__PURE__*/_react["default"].createElement(_Size["default"], {
    label: "Padding bottom",
    value: padding.bottom,
    onChange: onValueChange('padding', 'bottom'),
    options: options[_const.TYPE_PADDING]
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex align-items-end"
  }, /*#__PURE__*/_react["default"].createElement(_Size["default"], {
    label: "Padding left",
    value: padding.left,
    onChange: onValueChange('padding', 'left'),
    options: options[_const.TYPE_PADDING]
  }), /*#__PURE__*/_react["default"].createElement(_Lock["default"], {
    locked: locks.padding.horizontal,
    onClick: onLockClick(_const.TYPE_PADDING, _const.DIRECTION_HORZ)
  }), /*#__PURE__*/_react["default"].createElement(_Size["default"], {
    label: "Padding right",
    value: padding.right,
    onChange: onValueChange('padding', 'right'),
    options: options[_const.TYPE_PADDING]
  })), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Halve Padding on Mobile",
    checked: paddingMobile,
    onChange: function onChange(e) {
      _onChange8(_defineProperty({}, _const.STATE_KEY_POSITION, _objectSpread(_objectSpread({}, positionDecoratorState), {}, _defineProperty({}, _const.TYPE_PADDING_MOBILE, e.target.checked))));
    }
  }), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex align-items-end"
  }, /*#__PURE__*/_react["default"].createElement(_Size["default"], {
    label: "Margin top",
    value: margin.top || 0,
    onChange: onValueChange('margin', 'top'),
    options: [].concat(negativeValues, _toConsumableArray(options[_const.TYPE_MARGIN]))
  }), /*#__PURE__*/_react["default"].createElement(_Lock["default"], {
    locked: locks.margin.vertical,
    onClick: onLockClick(_const.TYPE_MARGIN, _const.DIRECTION_VERT)
  }), /*#__PURE__*/_react["default"].createElement(_Size["default"], {
    label: "Margin bottom",
    value: margin.bottom || 0,
    onChange: onValueChange('margin', 'bottom'),
    options: [].concat(negativeValues, _toConsumableArray(options[_const.TYPE_MARGIN]))
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex align-items-end"
  }, /*#__PURE__*/_react["default"].createElement(_Size["default"], {
    label: "Margin left",
    value: margin.left,
    onChange: onValueChange('margin', 'left'),
    options: options[_const.TYPE_MARGIN]
  }), /*#__PURE__*/_react["default"].createElement(_Lock["default"], {
    locked: locks.margin.horizontal,
    onClick: onLockClick(_const.TYPE_MARGIN, _const.DIRECTION_HORZ)
  }), /*#__PURE__*/_react["default"].createElement(_Size["default"], {
    label: "Margin right",
    value: margin.right,
    onChange: onValueChange('margin', 'right'),
    options: options[_const.TYPE_MARGIN]
  }))), /*#__PURE__*/_react["default"].createElement(_Group["default"], {
    title: "Border"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "49%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.borderXInput,
    options: options[_const.TYPE_BORDER_X],
    value: borderX,
    onChange: function onChange(e) {
      return onBorderChange(e.value, _const.TYPE_BORDER_X);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "49%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.borderYInput,
    options: options[_const.TYPE_BORDER_Y],
    value: borderY,
    onChange: function onChange(e) {
      return onBorderChange(e.value, _const.TYPE_BORDER_Y);
    }
  }))), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    label: "".concat(translations.borderWidthInput, " (").concat(borderWidth, "px)"),
    min: 1,
    max: 20,
    step: 1,
    value: borderWidth,
    onChange: function onChange(e) {
      return onBorderChange(e.target.value, _const.TYPE_BORDER_WIDTH);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.borderColorInput,
    options: [].concat(_toConsumableArray(options[_const.TYPE_BORDER_COLOR]), _toConsumableArray(themeColours)),
    value: borderColor,
    onChange: function onChange(e) {
      return onBorderChange(e.value, _const.TYPE_BORDER_COLOR);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.borderStyleInput,
    options: options[_const.TYPE_BORDER_STYLE],
    value: borderStyle,
    onChange: function onChange(e) {
      return onBorderChange(e.value, _const.TYPE_BORDER_STYLE);
    }
  })), /*#__PURE__*/_react["default"].createElement(_Group["default"], {
    title: "Effects"
  }, /*#__PURE__*/_react["default"].createElement("h6", null, "Box Shadow"), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Display Box Shadow",
    checked: boxShadow,
    onChange: function onChange(e) {
      return onEffectChange(e.target.checked, _const.TYPE_BOX_SHADOW);
    }
  }), /*#__PURE__*/_react["default"].createElement("h6", null, "Entrance Animation"), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.animationStyleInput,
    options: options[_const.TYPE_ANIMATION_STYLE],
    value: animationStyle,
    onChange: function onChange(e) {
      return onEffectChange(e.value, _const.TYPE_ANIMATION_STYLE);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    label: "".concat(translations.animationDelayInput, " (").concat(animationDelay, "ms)"),
    min: 0,
    max: 5000,
    step: 100,
    value: animationDelay,
    onChange: function onChange(e) {
      return onEffectChange(e.target.value, _const.TYPE_ANIMATION_DELAY);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    label: "".concat(translations.animationDurationInput, " (").concat(animationDuration, "ms)"),
    min: 100,
    max: 5000,
    step: 100,
    value: animationDuration,
    onChange: function onChange(e) {
      return onEffectChange(e.target.value, _const.TYPE_ANIMATION_DURATION);
    }
  }), /*#__PURE__*/_react["default"].createElement("h6", null, "Hover Animation"), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: translations.animationStyleInput,
    options: options[_const.TYPE_ANIMATION_HOVER],
    value: animationHover,
    onChange: function onChange(e) {
      return onEffectChange(e.value, _const.TYPE_ANIMATION_HOVER);
    }
  })), /*#__PURE__*/_react["default"].createElement(_Group["default"], {
    title: "Anchor"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: translations.anchorIdInput,
    value: anchorId,
    onChange: function onChange(e) {
      onAnchorChange(e.target.value, _const.TYPE_ANCHOR_ID);
    },
    onBlur: function onBlur(e) {
      var value = e.target.value;

      if (!isNaN(parseFloat(value[0])) && isFinite(value[0])) {
        value = "id-".concat(value);
      }

      onAnchorChange(value.toLowerCase().replace(/([^A-Za-z0-9[\]{}_.:-])\s?/g, '-'), _const.TYPE_ANCHOR_ID);
    }
  })));
};

var _default = BlockDecoratorForm;
exports["default"] = _default;